import { Navigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/App";
import { reviewSuccessTarget } from "@/lib/reviewSuccess";

/**
 * /review/:reviewId/success — the Stripe return URL for an async review.
 *
 * Not a page of its own: it forwards the buyer to the existing review page
 * (/verifications/:id), or to login first and back if they are signed out.
 * Public route, because the buyer arrives straight from Stripe's hosted page.
 */
export default function ReviewSuccessRedirect() {
  const { reviewId } = useParams();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-brand-green animate-spin" />
      </div>
    );
  }

  return <Navigate to={reviewSuccessTarget(reviewId, Boolean(user))} replace />;
}
